<template>
  <article>
    <section class="section font-roboto">
      <div>
        <h1
          class="mb-8 text-[20px] leading-[26px] xl:text-[32px] xl:leading-[38px]"
        >
          Политика конфиденциальности мобильного приложения История.рф
        </h1>
        <h6
          class="mb-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ОПРЕДЕЛЕНИЕ ПОНЯТИЙ
        </h6>
        <div>
          <p>
            "Закон" - означает Федеральный закон Российской Федерации "О
            персональных данных" со всеми изменениями и дополнениями, а также
            иные законодательные акты Российской Федерации.
          </p>
          <p>
            "Контроллер" - означает лицо, которое является ответственным за
            обработку и защиту Персональных данных Пользователей, находящихся на
            территории ЕС в понимании Общего регламента защиты персональных
            данных (General Data Protection Regulation) от 27 апреля 2016 года
            (далее "GDRP").
          </p>
          <p>
            "Мобильное приложение" - это программное обеспечение (со всеми
            существующими дополнениями и улучшениями), предназначенное для
            работы на смартфонах, планшетах, часах и других мобильных
            устройствах, и разработанное для конкретной платформы (iOS, Android,
            Windows Phone и т. д.).
          </p>
          <p>
            "Персональные данные" - означает совокупность личных данных и/или
            неперсонифицированной информации о Пользователе, предоставляемую им
            самим Правообладателю и/или автоматически собираемую
            Правообладателем и/или третьими лицами.
          </p>
          <p>
            "Политика" - означает настоящую Политику конфиденциальности
            мобильного приложения (со всеми существующими дополнениями и
            изменениями).
          </p>
          <p>
            "Пользователь" - означает юридическое или физическое лицо, которое
            загрузило Мобильное приложение на смартфон, планшет, часы или любое
            другое мобильное устройство и/или осуществило активацию такого
            Мобильного приложения на одном из указанных устройств.
          </p>
          <p>
            "Пользовательское соглашение" - означает соглашение, заключаемое
            между Правообладателем и Пользователем в отношении порядка, правил и
            особенностей использования Пользователем Мобильного приложения.
            Пользователь присоединяется к такому соглашению и не имеет права
            вносить и/или требовать внесения в него каких-либо изменений или
            дополнений.
          </p>
          <p>
            "Правообладатель" - означает следующее лицо, которому принадлежат
            исключительные права владения Мобильным приложением: Общероссийская
            общественно-государственная организация «Российское
            военно-историческое общество» (ИНН/КПП: 7730185220 / 770701001)
            Адрес: 107031, город Москва, Петровский переулок, дом 6, строение 1
          </p>
          <p>
            "Процессор" - означает лицо, которое в понимании GDRP по поручению
            Контроллера выполняет хранение и/или обработку Персональных данных,
            полученных от Пользователей.
          </p>
          <p>
            "Файлы куки" - означает небольшие файлы, отправляемые каким-либо
            мобильным приложениям или сайтом, и размещаемые на смартфонах,
            планшетах, часах и других мобильных устройствах Пользователя, для
            улучшения работы таких приложений или сайтов, а также качества
            размещенного в них контента.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ОБЩИЕ ПОЛОЖЕНИЯ
        </h6>
        <div>
          <p>
            Данная политика конфиденциальности (далее «Политика
            конфиденциальности») описывает сбор и использование личных данных,
            которые компания получает от пользователя, а также права в отношении
            личных данных при посещении нашего мобильного приложения.
          </p>
          <p>
            Настоящая Политика конфиденциальности не распространяется на любую
            информацию, которую компания может получить о Вас из других
            источников, кроме использования нашего мобильного приложения.
            Мобильное приложение может предоставлять доступ к другим сайтам или
            мобильным приложениям, но настоящая Политика конфиденциальности не
            распространяется и не будет применяться ни к одному из этих сайтов
            или приложений.
          </p>
          <p>
            Компания стремится защищать Вашу личную информацию во время
            использования нашего мобильного приложения.
          </p>
          <p>
            Продолжая использовать данное мобильное приложение, Вы
            подтверждаете, что ознакомились с Политикой конфиденциальности, и
            подтверждаете своё согласие. Это означает, что Вы также соглашаетесь
            на использование Вашей информации и метода раскрытия информации,
            согласно настоящей Политике конфиденциальности. Если Вы не
            принимаете данную Политику конфиденциальности или не согласны с ней,
            Вы соглашаетесь немедленно прекратить использование данного
            мобильного приложения.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ПРАВА ПОЛЬЗОВАТЕЛЯ ПО ЗАЩИТЕ ПЕРСОНАЛЬНЫХ ДАННЫХ
        </h6>
        <p>
          В связи с предоставлением Персональных данных Пользователь
          автоматически получает следующие права:
        </p>
        <div>
          <p>
            1) получать данные, касающиеся их обработки (основания и цели такой
            обработки, применяемые способы обработки, сведения о лицах, которые
            имеют доступ к ним или которым они могут быть раскрыты на основании
            договора или Закона).
          </p>
          <p>
            2) получать данные о месте нахождения и идентификационных данных
            лиц, совершающих обработку Персональных данных.
          </p>
          <p>3) получать данные о сроках хранения Персональных данных.</p>
          <p>
            4) получать данные об осуществленной или о предполагаемой
            трансграничной передаче Персональных данных.
          </p>
          <p>
            5) обжаловать действия или бездействие Правообладателя в
            уполномоченный орган по защите прав субъектов персональных данных
            или в судебном порядке.
          </p>
          <p>
            6) получать возмещение убытков и/или компенсацию морального вреда в
            судебном порядке в следствие допущенных Правообладателем и/или
            третьими лицами нарушений прав Пользователя на охрану и защиту его
            Персональных данных.
          </p>
          <p>
            7) реализовывать иные права в области защиты персональных данных,
            предусмотренные Законом или положениями данной Политики.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ПЕРЕЧЕНЬ СОБИРАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ
        </h6>
        <p>Неперсонифицированная информация о пользователях</p>
        <p>
          В связи с использованием Мобильного приложения Правообладатель может
          автоматически собирать и обрабатывать следующею неперсонифицированную
          информацию о Пользователе:
        </p>
        <div>
          <p>
            1) информацию о трафике, возможном количестве совершенных кликов,
            логи и другие данные.
          </p>
          <p>
            2) информацию об устройстве (идентификационный номер, сеть
            мобильного оператора), с которого выполняется вход, операционная
            система, платформа, тип браузера и другая информация о браузере, IP
            адрес.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Личные данные о пользователях
        </h6>
        <p>
          Пользователь предоставляет Правообладателю о себе следующие личные
          данные:
        </p>
        <div>
          <p>
            1) данные и информация, получаемая в результате объединения тех или
            иных Персональных данных конкретного Пользователя, а также данные и
            информация, получаемые данные о Пользователе, получаемые от третьих
            лиц (партнеров, маркетологов, исследователей). Пользователь является
            единственным ответственным лицом за полноту предоставляемых личных
            (персональных) данных и обязан осуществлять своевременное их
            изменение (обновление, проверку, корректировку) на регулярной
            основе. Правообладатель исходит из того, что все предоставленные
            Пользователем личные (персональные) данные являются достоверными, и
            что Пользователь поддерживает такую информацию в актуальном
            состоянии.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Использование файлов куки
        </h6>
        <p>
          Данное Мобильное приложение применяет определенные Файлы куки для
          сохранения IP-адреса, предпочтений Пользователей или типа
          используемого устройства с целью:
        </p>
        <div>
          <p>1) ведения статистики посещений и трафика сайта,</p>
          <p>2) персонализации выводимых на экран Пользователя данных,</p>
          <p>
            3) сохранения данных, необходимых для идентификации Пользователя, в
            том числе при доступе с разных устройств,
          </p>
          <p>
            4) показа рекламы в соответствии с интересами и предпочтениями
            Пользователя.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Мобильное приложение может использовать как собственные Файлы куки,
          принадлежащие Правообладателю, так и Файлы куки третьих лиц.
        </h6>
        <p>Мобильное приложение использует следующие Файлы куки:</p>
        <div>
          <p>
            1) Технические (функциональные) Файлы куки, которые нужны для
            контроля трафика и передачи данных, для идентификации Пользователей
            и предоставления доступа Пользователю к контенту Мобильного
            приложения и без которых использование Мобильного приложения
            является функционально ограниченным, а также для предотвращения
            предоставления рекомендаций, не соответствующих интересам
            Пользователя.
          </p>
          <p>
            2) Файлы куки третьих лиц, которые устанавливаются третьими лицами с
            разрешения Пользователя и предназначены для проведения
            статистических исследований, касающихся поведения Пользователя в
            сети Интернет и/или направления персонализированных рекламных или
            маркетинговых материалов Пользователю и/или предоставления товаров
            или услуг.
          </p>
        </div>
        <p>
          Пользователь имеет право в любой момент отключить Файлы куки в
          Мобильном приложении путем изменения определенных настроек в своем
          смартфоне, планшете, часах или другом мобильном устройстве. Такое
          отключение может повлечь за собой ограничение или изменение доступа
          Пользователя к функциональным возможностям Мобильного приложения и/или
          контенту. Для отключения Файлов куки нужно выполнить следующие
          действия:
        </p>
        <p>
          Зайти на устройстве в браузер, перейти в "Настройки" затем выбрать
          "Файлы куки", затем "Изменение настроек" и задать нужную конфигурацию.
        </p>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ЦЕЛИ СБОРА И ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
        </h6>
        <p>Определение целей обработки.</p>
        <p>
          Сбор и обработка Персональных данных осуществляется в следующих целях:
        </p>
        <div>
          <p>
            1) для анализа поведения Пользователя, а также выявления
            предпочтений Пользователя к определенному виду контента.
          </p>
          <p>
            2) для оперативной и корректной работы Мобильного приложения,
            улучшения функционирования работы Мобильного приложения, улучшения
            контента Мобильного приложения, улучшения внутренней архитектуры и
            функциональности Мобильного приложения.
          </p>
          <p>3) для идентификации Пользователя.</p>
          <p>4) для соблюдения требований Закона.</p>
          <p>
            5) для технической поддержки Мобильного приложения, выявления
            проблем в его работе и их устранение.
          </p>
          <p>6) для поддержания связи с Пользователем (коммуникация).</p>
          <p>
            7) для выполнения иных обязательств Правообладателя, которые
            возникли перед Пользователем.
          </p>
          <p>
            8) для любых других целей, при условии получения отдельного согласия
            от Пользователя.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Обработка Персональных данных осуществляется на основе принципов:
        </h6>
        <div>
          <p>1) законности целей и способов обработки;</p>
          <p>2) добросовестности;</p>
          <p>
            3) соответствия целей обработки Персональных данных целям, заранее
            определенным и заявленным при сборе таких Персональных данных;
          </p>
          <p>
            4) соответствия объема и характера обрабатываемых Персональных
            данных заявленным целям их обработки.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Условия обработки персональных данных
        </h6>
        <p>Обработка Персональных данных проводится в случаях:</p>
        <div>
          <p>1) получения согласия от Пользователя;</p>
          <p>
            2) достижения Правообладателем целей, предусмотренных международным
            договором или Законом;
          </p>
          <p>
            3) предоставления Пользователем своих Персональных данных
            неограниченному кругу лиц;
          </p>
          <p>
            4) выполнения иных обязательств Правообладателя перед Пользователем,
            включая, однако не ограничиваясь, предоставление определенного
            контента Пользователю;
          </p>
          <p>
            5) спасения жизни или здоровья Пользователя, когда согласие на
            обработку его Персональных данных не удается получить
            заблаговременно.
          </p>
        </div>
        <p>
          В случае обезличивания Персональных данных, что не позволяет прямо или
          опосредованно определить Пользователя, последующее использование и
          раскрытие таких данных третьим лицам допускается и в отношении их
          более не применяются правила данной Политики.
        </p>
        <p>
          Правообладатель принимает все возможные меры для защиты
          конфиденциальности полученных Персональных данных, за исключением
          случаев, когда Пользователь сделал такие данные общедоступными.
        </p>
        <p>
          Обработка Персональных данных осуществляется с использованием средств
          автоматизации и без использования таких средств автоматизации.
        </p>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ДОСТУП ТРЕТЬИХ ЛИЦ К ПЕРСОНАЛЬНЫМ ДАННЫМ
        </h6>
        <p>Раскрытие персональных данных третьим лицам.</p>
        <p>Правообладатель имеет право раскрывать Персональные данные:</p>
        <div>
          <p>
            1) своим аффилированным лицам, филиалам и представительствам,
            открытым как на территории Российской Федерации, так и на территории
            других государств;
          </p>
          <p>
            2) правопреемникам Правообладателя, которые возникли в результате
            его ликвидации, реорганизации или банкротства, и которые получили
            исключительные права владения Мобильным приложением;
          </p>
          <p>
            3) третьим лицам исключительно для целей оказания получения
            Пользователем определенного контента или доступа к нему;
          </p>
          <p>
            4) третьим лицам, когда Пользователем было дано согласие на
            раскрытие, передачу или обработку своих Персональных данных, а также
            в иных случаях, прямо предусмотренных Законом или данной Политикой.
          </p>
        </div>
        <p>
          Правообладатель раскрывает Персональные данные только в том случае,
          если:
        </p>
        <div>
          <p>
            1) уверен, что третьи лица будут соблюдать условия данной Политики и
            предпринимать такие же меры по защите конфиденциальности
            Персональных данных, которые предпринимает сам Правообладатель;
          </p>
          <p>
            2) согласие на такое раскрытие было предварительно выражено
            Пользователем и/или допускается на основании Закона.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          РАЗМЕЩЕНИЕ РЕКЛАМЫ
        </h6>
        <p>Реклама в мобильном приложении</p>
        <p>Правообладатель не размещает рекламу в Мобильном приложении.</p>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          НАПРАВЛЕНИЕ ЖАЛОБ И ЗАПРОСОВ ПРАВООБЛАДАТЕЛЮ
        </h6>
        <p>Требование о прекращении обработки персональных данных</p>
        <p>
          Каждый Пользователь имеет право выразить свое возражение
          Правообладателю против обработки и/или хранения его Персональных
          данных. Такое возражение может быть выражено следующим образом:
        </p>
        <p>путем отправки письма на почту rvio@rvio.org</p>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Запрос на получение информации о персональных данных
        </h6>
        <p>
          Если у Пользователя возникают вопросы, связанные с порядком применения
          или использования настоящий Политики, порядком и/или способом
          обработки Персональных данных, Пользователь может задать такой вопрос
          следующим образом:
        </p>
        <p>путем отправки письма на почту rvio@rvio.org</p>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Изменение (обновление, дополнение, корректировка) или удаление
          персональных данных
        </h6>
        <p>
          Пользователь имеет право в любой момент изменить или удалить
          Персональные данные посредством направления специального запроса
          Правообладателю по следующему адресу: путем отправки письма на почту
          rvio@rvio.org
        </p>
        <p>
          Правообладатель имеет право отказать в изменении или удалении
          Персональных данных, если такие действия приведут:
        </p>
        <div>
          <p>1) к нарушению правил настоящей Политики;</p>
          <p>2) к нарушению Закона;</p>
          <p>
            3) характер Персональных данных является доказательством в
            каком-либо судебном процессе, возникшем между Правообладателем и
            Пользователем.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          СРОКИ И ПОРЯДОК ХРАНЕНИЯ ПЕРСОНАЛЬНЫХ ДАННЫХ
        </h6>
        <p>Хранение осуществляется самостоятельно Правообладателем.</p>
        <p>
          Хранение осуществляется в течение следующего срока: 3 года от момента
          получения такой информации.
        </p>
        <p>
          После окончания срока хранения Персональных данных, такие данные
          подлежат немедленному их уничтожению или обезличиванию, если только
          иное не запрещено Законом или положениями данной Политики.
        </p>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ДОСТУП НЕСОВЕРШЕННОЛЕТНИХ К МОБИЛЬНОМУ ПРИЛОЖЕНИЮ
        </h6>
        <div>
          <p>Пользователи на территории Российской Федерации</p>
          <p>
            Мобильное приложение может быть использовано лицами в возрасте до 6
            лет.
          </p>
          <p>
            Мобильное приложение собирает личные данные о Пользователях, потому
            использование настоящего приложения несовершеннолетними
            Пользователями допускается только при условии получения
            предварительного согласия от законного представителя (опекуна) на
            обработку Персональных данных. Такое согласие должно быть
            предоставлено следующим способом:
          </p>
          <p>
            Направление скана паспорта законного представителя на следующий
            электронный адрес: rvio@rvio.org
          </p>
          <p>
            Если несовершеннолетний Пользователь не может предоставить согласие
            на обработку его Персональных данных от законного представителя
            (опекуна), в таком случае такой Пользователь обязан немедленно
            прекратить использование Мобильного приложения.
          </p>
          <p>Пользователи на территории Европейского Союза</p>
          <p>
            Мобильное приложение и/или его контент предназначен для лиц в
            возрасте до 16 лет.
          </p>
          <p>
            Поскольку Мобильное приложение собирает личные данные о
            Пользователях, использование настоящего приложения Пользователями в
            возрасте до 16 лет (если только меньший порог не установлен
            национальным законодательством государства-члена Европейского Союза,
            на территории которого предоставляется доступ к Мобильному
            приложению) допускается только при условии получения
            предварительного согласия от законного представителя (опекуна) на
            обработку Персональных данных, которое должно быть предоставлено
            следующим способом:
          </p>
          <p>
            Направление скана паспорта законного представителя на следующий
            электронный адрес: rvio@rvio.org
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ПОРЯДОК ЗАЩИТЫ ПЕРСОНАЛЬНЫХ ДАННЫХ
        </h6>
        <p>
          Защита конфиденциальности Персональных данных является первостепенной
          и важной задачей для Правообладателя. Правообладатель придерживается
          всех требуемых международных стандартов, правил и рекомендаций по
          защите Персональных данных.
        </p>
        <p>
          Правообладатель внедрил ряд технических и организационных методов,
          направленных на защиту Персональных данных от разглашения или
          несанкционированного доступа к ним третьих лиц.
        </p>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ПОЛЬЗОВАТЕЛИ, НАХОДЯЩИЕСЯ НА ТЕРРИТОРИИ ЕВРОПЕЙСКОГО СОЮЗА
        </h6>
        <p>Общие положения</p>
        <div>
          <p>
            Поскольку Мобильное приложение является доступным для пользователей
            из Европейского союза, Правообладатель обязуется дополнительно
            придерживаться положений GDRP.
          </p>
          <p>
            Контроллером в понимании настоящей Политики является
            Правообладатель.
          </p>
          <p>
            Правообладатель осуществляет хранение Персональных данных в течение
            разумного срока, необходимого для достижения целей обработки, однако
            не меньше срока, установленного локальным законодательством
            государства-члена Европейского союза, на территории которого
            доступно Мобильное приложение, для хранения того или иного вида
            Персональных данных. По истечению срока, установленного для
            хранения, Правообладатель обязуется немедленно уничтожить или
            обезличить такие данные.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Права пользователей в области защиты персональных данных
        </h6>
        <div>
          <p>
            Согласно Главе 3 GDRP Пользователи, находящиеся на территории
            Европейского Союза, имеют следующие права в области защиты
            Персональных данных:
          </p>
          <p>
            1) право на получение информации о своих Персональных данных ("the
            right to be informed");
          </p>
          <p>
            2) право на доступ к своим Персональным данным ("the right of
            access");
          </p>
          <p>
            3) право на исправление Персональных данных ("the right to
            rectification");
          </p>
          <p>
            4) право на уничтожение Персональных данных ("the right to
            erasure");
          </p>
          <p>
            5) право на ограничение обработки Персональных данных ("the right to
            restrict processing");
          </p>
          <p>
            6) право на перенос Персональных данных третьим лицам ("the right to
            data portability");
          </p>
          <p>7) право на возражение ("the right to object").</p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
        </h6>
        <div>
          <p>Доступность текста политики для ознакомления.</p>
          <p>
            Пользователи могут ознакомиться с условиями данной Политики по
            следующей ссылке:
            <NuxtLink
              to="/privacy_policy_application"
              target="_blank"
              class="text-ruby-red-100"
              >{{ useHostApp() }}/privacy_policy_application</NuxtLink
            >
          </p>
          <p>
            Данная Политика может быть переведена на иностранный язык для тех
            Пользователей, которые осуществляют доступ к Мобильному приложению
            за пределами Российской Федерации. В случае расхождения текста
            оригинала (русский язык) и его перевода, преимущественную силу имеет
            язык оригинала.
          </p>
          <p>Данная редакция Политики действует с 01 января 2024 года.</p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Изменение и дополнение политики
        </h6>
        <div>
          <p>
            Настоящая Политика может быть изменена время от времени.
            Правообладатель не несет какой-либо ответственности перед
            Пользователем за изменение условий данной Политики без разрешения
            и/или согласия Пользователя.
          </p>
          <p>
            Пользователь сам обязуется на регулярной основе проверять положения
            данной Политики на предмет ее возможного изменения или дополнения.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Применимое законодательство
        </h6>
        <div>
          <p>
            Настоящая Политика разработана в соответствие с действующим
            законодательством о защите персональных данных Российской Федерации,
            в частности, с нормами Федерального закона от 27 июля 2006 года №
            152-ФЗ "О персональных данных" (со всеми дополнениями и
            изменениями), Федерального закона от 21 июля 2014 года № 242-ФЗ "О
            внесении изменений в отдельные законодательные акты Российской
            Федерации в части уточнения порядка обработки персональных данных в
            информационно-телекоммуникационных сетях" (со всеми дополнениями и
            изменениями), а также положениями Общего регламента защиты
            персональных данных (General Data Protection Regulation) от 27
            апреля 2016 года GDRP.
          </p>
        </div>
        <h6
          class="my-2 text-[16px] font-medium leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          Риск разглашения
        </h6>
        <div>
          <p>
            Вне зависимости от предпринимаемых Правообладателем мер защиты
            конфиденциальности получаемых персональных данных, Пользователь
            настоящим считается должным образом ознакомлен с тем, что любая
            передача Персональных данных в сети Интернет не может быть
            гарантировано безопасной, а потому Пользователь осуществляет такую
            передачу на свой собственный риск.
          </p>
        </div>
      </div>
    </section>
  </article>
</template>

<script setup>
useHead({
  title: 'Политика в отношении обработки персональных данных | История РФ',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: 'Федеральный портал Истории России',
    },
  ],
});
</script>

<style scoped lang="scss">
.section {
  @apply max-md:text-sm;
}
</style>
